import * as types from './actionTypes';  
import completeAllocationApi from '../api/completeAllocationApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doCompleteAllocation(id) {

  return {
    type: types.DO_COMPLETE_ALLOCATION, 
    id
  };
}

export function doCompleteAllocationRes(data) {  
  return {
    type: types.DO_COMPLETE_ALLOCATION_RES, 
    data
  };
}
export function sendCompleteAllocation(id) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      completeAllocationApi.doCompleteAllocation(id).then(data => {
        dispatch(doCompleteAllocationRes(data));
        dispatch(doCompleteAllocationRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}